export default class MapFilter {

    constructor(props={}, onlineAppNavOption=null) {
        this.onlineAppNavOption = onlineAppNavOption;

        this.name = props.name;
        this.code = props.code;
        this.slug = props.slug;
        this.experienceIds = props.experienceIds;
    }

    includesExperience(experience) {
        if (!experience) { return false }
        return this.experienceIds.includes(experience.id);
    }

    getMapTitle() {
        if (this.onlineAppNavOption) return this.onlineAppNavOption.getMapTitle();
        return this.name;
    }

}